import { render, staticRenderFns } from "./ProfileTransactions.vue?vue&type=template&id=dc1b76c8&"
import script from "./ProfileTransactions.vue?vue&type=script&lang=js&"
export * from "./ProfileTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports